export const useUserStore = defineStore('User', () => {
  const { user, session } = useUserSession()

  const organizations = computed(() => user.value?.organizations ?? [])

  // The session holds all organizations of the user. One of them is active.
  const organization = computed(
    () =>
      organizations.value.find(({ id }) => id === session.value?.activeOrganizationId) ?? organizations.value[0] ?? null
  )

  const groups = computed<string[]>(() => user.value?.groups ?? [])

  return {
    user: user.value,
    organization,
    organizations,
    groups
  }
})
